import {AfterViewInit, Directive, ElementRef, inject, Input} from "@angular/core";
import {ErrorPointer, ErrorWithPointers} from "./errors";
import {sendHandlerQuery} from "../handlers/app-common-utils";

@Directive({
    selector: '[errorIndicator]',
    standalone: false
})
export class ErrorIndicatorDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private initialized: boolean;

  @Input() indicatorEnabled: boolean = true;
  @Input() queryName: string = "getErrors";
  @Input() screenPointer: string;
  @Input() overrideRef: ElementRef;
  @Input() predicate: (errorPointer: ErrorPointer) => boolean;
  @Input() mainPredicate: (errorPointer: ErrorWithPointers) => boolean;

  errors: ErrorWithPointers[];

  ngAfterViewInit(): void {
    if (!this.indicatorEnabled) {
      return;
    }
    if (!this.screenPointer && !this.predicate && !this.mainPredicate) {
      console.error("One of 'screenPointer', 'mainPredicate' or 'predicate' is required");
      return;
    }
    this.initialized = true;
    this.setError();
  }

  private updateElement = () => {
    if (this.initialized) {
      this.renderErrorElement();
    }
  }

  private renderErrorElement = () => {
    const wrapper = $(this.ensureWrapped());
    if (this.hasError) {
      wrapper.addClass("has-error");
      this.inlineElement().text(this.screenPointer ? this.errors[0].header : "");
      wrapper.parent().addClass("text-invalid");
      setTimeout(() => {
        wrapper.closest(".nav-link").first()
          .addClass("was-validated");
      }, 0);
    }
  }

  private inlineElement() {
    const wrapper = $(this.ensureWrapped());
    const spanElement = wrapper.find(".error-inline");
    return spanElement.length > 0 ? spanElement : wrapper
      .append(this.errorInlineElement())
      .find(".error-inline");
  }

  private errorInlineElement = () => {
    return $(
      `<div class="prevent-drag-move error-inline-wrapper text-danger d-inline-block">
            <i class="fa-kit fa-fw fa-pb-circle-xmark-solid"></i>
            <span class="error-inline"></span>
      </div>`);
  }

  private ensureWrapped() {
    const element = $(this.elementRef.nativeElement);
    const parent = element.parent();
    if (parent.hasClass('error-wrapper')) {
      return parent;
    } else {
      return element.wrap($(document.createElement("div")).addClass('error-wrapper d-inline-block')).parent();
    }
  }

  private get hasError(): boolean {
    return !!this.errors?.length;
  }

  private setError(): void {
    sendHandlerQuery(this.queryName, undefined, undefined, this.overrideRef || this.elementRef)
      .subscribe((e: ErrorWithPointers[]) => {
        const predicate = this.predicate || (p => p.screenPointer === this.screenPointer);
        const mainPredicate = this.mainPredicate || (e => e.pointers.some(predicate));
        this.errors = e?.filter(mainPredicate).map(e => ({
          ...e,
          pointers: e.pointers.filter(predicate)
        })) || [];
        this.updateElement();
      });
  }
}
